module.exports = __webpack_public_path__ + "static/img/yytx34.a83bbdb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx34.png
// module id = 901
// module chunks = 0